<template>
  <div :style="themeStyle">
    <div>
        <v-row class="headline1_bg p-3" no-gutters>
          <v-col cols="12">
            บทความ
          </v-col>
        </v-row>
        <br>
        <all-blog></all-blog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AllBlog from '../AllBlog'

export default {
  name: 'Blog',
  components: {
    'all-blog': AllBlog
  },
  data () {
    return {
      member: null,
      profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Blog/Blog.vue